import identity from '../../utils/identity';
import { CARTS_MERGED } from '../../state/redux/action-types';

const initializeUser = async ({ onCartUpdate, fetchCartCallback = identity, shopInstance }) => {
  const isLoggedIn = await window.webShellClient.identity.getIsLoggedIn();

  if (isLoggedIn) {
    await window.NikeShop.mergeCarts();
    await onCartUpdate();

    shopInstance.internalStore.dispatch({ type: CARTS_MERGED });
    window.NikeShop.initializeWishlist();
  }

  fetchCartCallback();
};

export default initializeUser;
